
import React, {Component} from 'react';
import ReactDOM, { render } from 'react-dom';
import Mask from 'c-mask';
import Layer from 'c-layer';
import lang from '../lang/index';
import InvoiceDialog from './dialog-invoice';
import cache from '../global/cache';

class BoxLayer extends Component {
	static defaultProps = {
		orderData:{},
	}
	constructor(props){
		super(props);
		this.state = {
			visible:0
		};
	}
	componentWillMount(){
		this.show();
	}
	show(){
		this.setState({
			visible: 1
		},()=>{
			this.showAnim();
		});
	}
	showAnim(callback){
		let self = this;
		let el = this.refs.content;
        function endFun() {
            if (typeof callback == 'function') {
                callback();
            }
            el.removeEventListener("webkitTransitionEnd", endFun)
        }
        el.style.WebkitTransition = "-webkit-transform 0.2s ease-in";
        el.addEventListener("webkitTransitionEnd", endFun, false);

        setTimeout(function(){
            el.style.WebkitTransform = "translate3d(0,0,0)";
        },0);


	}
	hideAnim(callback){
		let self = this;
        let el = this.refs.content;

        function endFun() {
            if (typeof callback == 'function') {
                callback();
            }
            el.removeEventListener("webkitTransitionEnd", endFun)
        }
        el.style.WebkitTransition = "-webkit-transform .2s ease-in";
        el.addEventListener("webkitTransitionEnd", endFun, false);

        setTimeout(function(){
            el.style.WebkitTransform = "translate3d(0, 100%, 0)";
        }, 0);
	}
	handleClose = ()=>{
		let self = this;
        this.hideAnim(function(){
            self.props.onHide();
        });
	}
	handleSubmit = ()=>{


		let userInfo =  cache.getCache('userInfo');
		this.handleClose();
		this.props.orderData.orderBank = lang.template('永兴银行');
		InvoiceDialog.create({
			orderData:this.props.orderData,
			userInfo:userInfo
		});

	}
	render(){
		if(this.state.visible){
			let userInfo =  cache.getCache('userInfo');

			return (
					<div className="box-layer">
						<div className="box-wrapper" ref="content">
							<div className="box-hd">
								<div className="title">
								{lang.template('充值信息')}
								</div>
								<div className="close" onClick={this.handleClose}></div>
							</div>
							<div className="content">
								<div className="user-account">
									<div className="info">
										<label className="account-label">{lang.template('充值账户:')}</label>
										<div className="account-info">
											<span className="name">{userInfo.username}</span>
											({lang.template('Up号:')}{userInfo.upliveCode})
										</div>
									</div>
									<div className="info">
										<label className="account-label">{lang.template('充值额度:')}</label>
										<span className="account-info">{this.props.orderData.amount}</span>
									</div>
								
									<div className="need-pay">
										<div className="title">{lang.template('需支付')}</div>
										<div className="pay-money">{this.props.orderData.moneySymbol}{this.props.orderData.money}</div>

									</div>
								</div>
								<div className="banklist">
									<h3>{lang.template('选择银行')}</h3>
									<ul>
										<li>
											<div className="bankitem">{lang.template('永兴银行')}</div>
											<div className="chose selected"></div>
										</li>
									</ul>

								</div>


							</div>
							<div className="box-fd">
								<div className="btn" onClick={this.handleSubmit}>{lang.template('确认充值')}</div>
							</div>
						</div>
						<div className="box-mask" onClick={this.handleClose}></div>

					</div>

				);
		}else{
			return (<div style={{display: 'none'}}></div>);
		}
	}

}

module.exports = {

	create:function(cfg){
		cfg = cfg || {};
		console.log(this);
		if (this.layer) {
			this.destroy();
		}
		let mountNode = this.createMountNode();
		console.log(mountNode);
		this.layer = ReactDOM.render(<BoxLayer {...cfg} onHide={this.onHide.bind(this)}/>,mountNode);
	},
	onHide:function(){
		console.log('ssssss');
		console.log(this);
		this.destroy();
	},
	createMountNode:function(){
		this.mountNode = document.createElement('div');
		$(document.body).append(this.mountNode);
		return this.mountNode;
	},
	destroy:function(){
		if(this.mountNode){
			ReactDOM.unmountComponentAtNode(this.mountNode);
			$(this.mountNode).remove();
			delete this.layer;
		}
	}
};


// WEBPACK FOOTER //
// ./js/popup/bank-pay-popup.js